<template>
    <div
        :key="chat.id.value"
        class="chat-interaction-list"
    >
        <chat-assistent-interaction-item
            v-if="placeholder"
            :interaction="placeholder"
            :assistent="assistent"
        />
        <component
            :is="getComponentForInteraction(interaction)"
            v-for="(interaction, index) in props.chat.interactions"
            :key="interaction.id"
            :assistent="assistent"
            :assistent-goals="assistentGoals"
            :interaction="interaction"
            :url="urls[index]"
        />
    </div>
</template>

<script setup lang="ts">
    import { Assistent, Chat, ChatConnectGoal, Interaction, InteractionId, InteractionOrigin, InteractionType } from '@keyvue/one-api-client';
    import ChatFunctionInteractionItem from '@/ai/assistent/components/interaction/ChatFunctionInteractionItem.vue';
    import ChatUserInteractionItem from '@/ai/assistent/components/interaction/ChatUserInteractionItem.vue';
    import ChatAssistentInteractionItem from '@/ai/assistent/components/interaction/ChatAssistentInteractionItem.vue';
    import { computed, onMounted, ref } from 'vue';

    const props = defineProps<{
        assistent: Assistent,
        assistentGoals: ChatConnectGoal[],
        chat: Chat;
    }>();

    const placeholder = ref();

    onMounted(() => {
        placeholder.value = new Interaction(
            props.chat,
            new InteractionId('test'),
            InteractionType.MESSAGE,
            InteractionOrigin.ASSISTENT,
            '',
            '',
            props.assistent?.widget?.greeting ?? 'Hallo',
            [],
            props.chat.createdAt,
        );
    });

    const urls = computed(() => {
        let url = '';
        return [...props.chat.interactions].map((interaction) => {
            if (!interaction.url || url === interaction.url) {
                return '';
            }

            url = interaction.url;

            return url;
        });
    });

    function getComponentForInteraction(interaction: Interaction) {
        if (InteractionType.FUNCTION.equals(interaction.type)) {
            return ChatFunctionInteractionItem;
        }

        if (InteractionOrigin.USER.equals(interaction.origin)) {
            return ChatUserInteractionItem;
        }

        if (InteractionOrigin.ASSISTENT.equals(interaction.origin)) {
            return ChatAssistentInteractionItem;
        }

        return null;
    }
</script>

<style scoped lang="scss">
    .chat-interaction-list {
        display: flex;
        flex-direction: column;
        height: calc(100% - 80px);
        background-color: #F5F7FB;
        overflow-y: scroll;
        padding: size(md);
        gap: size(md);
        box-sizing: border-box;
    }
</style>
